'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


var _defaultDropLocationFn = require('../element/dnd/defaultDropLocationFn');

var _defaultDropLocationFn2 = _interopRequireDefault(_defaultDropLocationFn);

var _elementHelper = require('../../common/elements/elementHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props, monitor, component) {
    var dropResult = (0, _defaultDropLocationFn2.default)(props, monitor, component);

    // Can't drop lines onto the inbox

    var _monitor$getItem = monitor.getItem(),
        draggedElements = _monitor$getItem.draggedElements;

    var acceptedElementIds = draggedElements.filter(function (el) {
        return !(0, _elementHelper.isLine)(el);
    }).map(function (el) {
        return el.get('id');
    });

    return _extends({}, dropResult, {
        acceptedElementIds: acceptedElementIds
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/inboxDropLocationFn.js
// module id = 459
// module chunks = 0